import React from "react";
import { Icon } from "react-native-elements";
import { goBack } from "../../routes/Global";

const CloseIcon = ({ onPress, color }) => (
  <Icon
    name="close"
    type="material"
    color={color ? color : "white"}
    onPress={onPress ? onPress : () => goBack()}
    size={35}
    style={{ marginTop: 5 }}
  />
);

export default CloseIcon;
